import ValidService from "@/service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional Mã tự sinh
  tieu_de: undefined, // required Tiêu đề (plain-text)
  gioi_thieu: undefined, // optional Nội dung giới thiệu ngắn gọn (plain-text)
  anh_id: undefined,
  anh_url: undefined,
  anh_show: false,
  anh_btn_show: false,
  anh_nho_id: undefined,
  anh_nho_url: undefined,
  anh_nho_show: false,
  anh_nho_btn_show: false,
  video_id: undefined,
  video_url: undefined,
  video_show: false,
  video_btn_show: false,
  duong_dan: undefined, // optional Đường dẫn chứa bài viết giới thiệu chi tiết (nếu có)
  thu_tu: undefined, // required Thứ tự hiển thị
  // required Cấu hình thời điểm hiệu lực
  hien_thi_ngay: [],
  hien_thi: {
    an: undefined, // required Cho biết có ẩn hay không
    hieu_luc_tu: undefined, // optional Thời điểm bắt đầu có hiệu lực
    hieu_luc_den: undefined, // optional Thời điểm hết hiệu lực
    dieu_kien: [], // required, array items: required, enum(all, android, ios, iphone, ipad, pc, windows, macos) Danh sách điều kiện hiển thị
  },
};

// validation form
model.validForm = {
  tieu_de: [ValidService.required, ValidService.checkSpaceString],
  thu_tu: [ValidService.required],
  hien_thi: {
    an: [ValidService.required],
    dieu_kien: [ValidService.required, ValidService.requiredChange],
  },
};
model.dieuKien = [
  { value: "all", label: "all" },
  { value: "android", label: "android" },
  { value: "ios", label: "ios" },
  { value: "iphone", label: "iphone" },
  { value: "ipad", label: "ipad" },
  { value: "pc", label: "pc" },
  { value: "windows", label: "windows" },
  { value: "macos", label: "macos" },
];
model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thu_tu",
  defaultSort: ["thu_tu", "descending"],
  filters: "",
  recordSelected: [],

  dataSearch: {
    value: {
      tieu_de: "",
      gioi_thieu: "",
      "hien_thi.an": "",
      dieu_kien: "",
    },
    valid: {
      tieu_de: [],
      thu_tu: []
    },
    operator: {
      tieu_de: ":regex_i:",
      gioi_thieu: ":regex_i:",
      "hien_thi.an": "",
      dieu_kien: ":in:",
    },
  },
};

export default model;
